import { OnInit, Output, EventEmitter, Optional, Inject, Component } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { BlanceKeyRestService } from '../../services/NXI-Balances.services';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { ActivatedRoute } from '@angular/router';
import { NxiContextUtils } from '@pershing/nxi-common';
declare let dojoApp: any;
@Component({
    selector: 'balances-summary',
    templateUrl: './balances-summary.component.html'
})
export class BalancesSummaryComponent implements OnInit {
    @Output() emitter = new EventEmitter();
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    subs1: Subscription;
    restData: any;
    acctRef: any;
    isSupRequired: boolean = false;
    nxiRestServiceUrl: any;
    balancesRestJson: any;
    balancesDownloadLinkParams: any;
    balancesKeyParams: any;
    balancesDetailsvalParams: any;
    finalResponseJson: any;
    fundsFinalJson: any;
    asOfDate: any;
    asOfTime: any;
    prevAcctRef: any;
    realTimeActive: boolean = false;
    finalData: any = null;
    isAdaTheme: boolean = false;
    title: string;
    isComponentLoaded: boolean;
    isMobile: boolean = false;
    showAssetCurrencyBalances: boolean = true;
    constructor(
        private contextService: IContextService, private balanceRestService: BlanceKeyRestService, private nxiRestService: NxiRestService,
        private nxiWidgetParamsService: NxiWidgetParamsService, private route: ActivatedRoute, @Optional() @Inject('AppSettings') appSettings: any,
        private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobile = true;
            this.showAssetCurrencyBalances = false;
        }
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isMobile = true;
        }
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'balances-summary';
        }
        if ( appSettings.ibdConfigMap.IBD === 'H1X') {
            this.isSupRequired = true;
        }
    }
    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (!this.isComponentLoaded || (this.prevAcctRef !== this.acctRef)) {
                this.isComponentLoaded = true;
                this.getBalancesKeyValuesData();
                this.prevAcctRef = this.acctRef;
            }
        });
        this.subs1 = this.route.queryParams.subscribe(params => {
            if (params.rt) {
                this.realTimeActive = params.rt;
                sessionStorage.setItem('realTimeActive', params.rt);
            }
        });

    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }

        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyBalanceCustodyDetail();
            dojoApp.destroyBalancesKeyValue();

        }
    }
    renderDojoWidget(balancesKeyValParams: any, balanceDetailsvalParams: any, balancesDownloadLinkParams: any) {
        if (dojoApp) {
            balancesKeyValParams.nxiRestBaseUrl = this.nxiRestServiceUrl;
            dojoApp.renderBalancesKeyValue(this.acctRef, balancesKeyValParams, balanceDetailsvalParams, balancesDownloadLinkParams, this.showAssetCurrencyBalances);
        }
    }

    getBalancesKeyValuesData() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            if (sessionStorage.getItem('realTimeActive') && 'true' === sessionStorage.getItem('realTimeActive')) {
                this.realTimeActive = true;
            } else {
                this.realTimeActive = false;
            }
            this.balanceRestService.getBalancesKeyValues(this.realTimeActive).subscribe(
                (respJson: Array<object>) => {
                    this.balancesRestJson = respJson;
                    this.balanceRestService.balancesResponse$.next(respJson);
                    if (this.balancesRestJson) {
                        this.asOfDate = this.balancesRestJson.asOfDate;
                        this.asOfTime = this.balancesRestJson.asOfTime;
                    }
                    this.finalData = this.balancesRestJson;
                    this.nxiWidgetParamsService.getWidgetParams(
                        this.acctRef, 'balanceKeyValues?' + 'asOfDate=' + this.asOfDate + '&' + 'asOfTime=' + this.asOfTime + '&rt=' + this.realTimeActive).subscribe(
                            resp => {
                                console.log('Retrived common REST Balances params : ', resp.response);
                                if (resp.response) {
                                    this.balancesKeyParams = resp.response;
                                    this.balancesKeyParams.fundsDueUrl = this.nxiRestServiceUrl + this.balancesKeyParams.fundsDueUrl;
                                    this.realTimeActive = this.balancesKeyParams.realTimeActive;
                                    this.emitter.emit(this.realTimeActive);
                                }
                                this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'balancesLinkData').subscribe(
                                    res => {
                                        console.log('Retrived common REST Balances params : ', res.response);
                                        if (res.response) {
                                            res.response.downloadUrl = this.nxiRestServiceUrl + res.response.downloadUrl;
                                            this.balancesDownloadLinkParams = res.response;
                                            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'balanceDetails').subscribe(
                                                resp1 => {
                                                    console.log('Retrived common REST Balances params : ', resp1.response);
                                                    if (resp1.response) {
                                                        this.balancesDetailsvalParams = resp1.response;
                                                        this.finalResponseJson = { ... this.balancesKeyParams, data: this.finalData };
                                                        console.log('balancesKeyParams---------->', this.finalResponseJson);
                                                        this.renderDojoWidget(this.finalResponseJson, this.balancesDetailsvalParams, this.balancesDownloadLinkParams);
                                                    }
                                                }
                                            );
                                        }
                                    }
                                );
                            }
                        );
                }
            );
        }
    }
}
